import React, { useContext } from 'react'
import { Position, Toaster } from '@blueprintjs/core'

const ToastContext = React.createContext()
const ToasterOven = Toaster.create({
  position: Position.TOP
})

export const useToast = () => useContext(ToastContext)

const oven = {
  showError: (message) => ToasterOven.show({ message, intent: 'danger' }),

  showSuccess: (message) => ToasterOven.show({ message, intent: 'success' })
}

export const ToastProvider = ({ children }) => {
  return (
    <ToastContext.Provider value={oven}>
      {children}
    </ToastContext.Provider>
  )
}